import React from 'react';
import { SVGs } from '../../constants/Svgs';
import CustomButton from '../UI/CustomButton';

interface StatBoxProps {
    text: string;
    currentMonthStat: number;
    lastMonthStat: number;
    isPercentage?: boolean;
    additionalStyle?: string;
}

const StatBox: React.FC<StatBoxProps> = ({ text, currentMonthStat, lastMonthStat, isPercentage, additionalStyle }) => {
    const variation = currentMonthStat - lastMonthStat;
    const displayStat = currentMonthStat % 1 === 0 ? currentMonthStat.toFixed(0) : currentMonthStat.toFixed(1);
    const displayVariation = variation % 1 === 0 ? variation.toFixed(0) : variation.toFixed(1);

    const variationColorClass = variation > 0 ? 'text-secondary-50' : variation === 0 ? 'text-grey-300' : 'text-red-100';

    return (
        <div className={additionalStyle ? additionalStyle : 'flex flex-col p-3 bg-backoffice-600 rounded-xl text-white gap-1 border border-transparent'}>
            <div className='flex flex-row items-center gap-1 bold large3'>
                {displayStat}
                {isPercentage && '%'}
                <p className={`${variationColorClass} bold normal`}>
                    {variation > 0 ? `(+${displayVariation}${isPercentage ? ' ppts' : ''})` : variation === 0 ? '-' : `(${displayVariation}${isPercentage ? ' ppts' : ''})`}
                </p>
                <CustomButton
                    Svg={variation > 0 ? SVGs.statIsUp : variation == 0 ? SVGs.statIsEqual : SVGs.statIsDown}
                    customStyle='stat-icon'
                />
            </div>
            <div className={`${additionalStyle ? 'text-backoffice-600' : 'text-backoffice-100'} regular large`}>
                {text}
            </div>
        </div>
    );
}

export default StatBox;
